import axios from "axios";

export default function findContactsByCustomerCategory(categoryId, userId) {
    return axios.get(
        "/dashboard/getCustomerContactsFromCategory/" + categoryId.toString() + "/" + userId.toString()
    );
}
